import { useState } from "react";
import { takeUnauthReason } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { clearSupportReturn, supportReturnUrl } from "../lib/support";
import { Icon } from "../ui/Icon";
import { Notice } from "../ui/States";
import { AuthLayout } from "../features/auth/AuthLayout";

const KNOWN = new Set(["support_ended", "support_access_disabled", "tenant_suspended", "session_expired"]);

/**
 * /destek-bitti — destek oturumu düştüğünde (süre doldu, panelden bitirildi, firma erişimi kapattı ya da askıya
 * alındı) giriş ekranı yerine açılır; yöneticiyi panele geri götürür.
 */
export function SupportEndedPage() {
  const { t } = useI18n();
  const [reason] = useState(() => {
    const r = takeUnauthReason();
    return r && KNOWN.has(r) ? r : "support_ended";
  });
  const [back] = useState(() => supportReturnUrl() ?? "/yonetim");
  return (
    <AuthLayout title={t("platform.ended.title")} lead={t("platform.ended.lead")}>
      <div className="form">
        <Notice tone="attention">{t(`platform.ended.reasons.${reason}`)}</Notice>
        <a className="btn btn--primary btn--lg btn--block" href={back} onClick={() => clearSupportReturn()}>
          <Icon name="arrow-left" size={20} />
          <span>{t("platform.ended.back")}</span>
        </a>
      </div>
    </AuthLayout>
  );
}
